import React from "react";
import dayjs from "dayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";

import StyledNotAllDayPicker from "./styles";

function NotAllDayPicker({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}) {
  return (
    <StyledNotAllDayPicker>
      <div className="not-all-day-picker">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div className="day-picker">
            <DatePicker
              label="Desde"
              value={dayjs(startDate)}
              onChange={(date) => {
                let newDate = dayjs(date).toISOString();
                newDate = newDate.split("T")[0];

                onStartDateChange(newDate);
              }}
            />
            <DatePicker
              label="Hasta"
              value={dayjs(endDate)}
              onChange={(date) => {
                let newDate = dayjs(date).toISOString();
                newDate = newDate.split("T")[0];

                onEndDateChange(newDate);
              }}
            />
          </div>
        </LocalizationProvider>
      </div>
    </StyledNotAllDayPicker>
  );
}

export default NotAllDayPicker;
